import { DraftService } from './../../services/draft.service';
import { MatDialog } from '@angular/material';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from 'shared/services/User/user.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-draft-queue',
  templateUrl: './draft-queue.component.html',
  styleUrls: ['./draft-queue.component.css']
})
export class DraftQueueComponent implements OnInit, OnDestroy {
  ALL_GAMES: any[] = [];
  _GAMES: any[];
/*   currentUID; */
  imgURLHandle = environment.URL_TEAM_IMAGES;
  thumbImgHandle = environment.URL_THUMB_IMAGES;
  _TEAM;
  queueGameSubscription;
  /*pickTicketSubscription; */

  constructor(
    public dialog: MatDialog,
    private draftService: DraftService,
    private userService: UserService) {
    this.queueGameSubscription = this.draftService.queueGameListTest$.subscribe(games => {
      this.ALL_GAMES = games;
      this.filterGames(games);
    });
  }

  ngOnInit() {
 /*    setTimeout(() => {
      this.currentUID = this.userService.user.uid;

      this._TEAM = this.draftService.CURRENT_GROUP.season_ticket.team;
      this.ALL_GAMES = this.draftService.getAvailableGames();
      this.filterGames(this.ALL_GAMES);
    }, 700); */

  }

  filterGames(games) {
    console.log('DRAFT QUEUE - Filtering games to display..');
    this._GAMES = games.filter(element => {
      return element.isQueued === true;
    });
    this._GAMES.sort((a, b) => parseFloat(a.q_tstamp) - parseFloat(b.q_tstamp));
  }

  queueGame(game, index) {
    if (!game.isQueued || game.isQueued === undefined) {
      game.q_tstamp = Date.now();
      game.q_uid = this.userService.user.uid;
      game.isQueued = true;
    } else {
      game.isQueued = !game.isQueued;
      game.q_tstamp = 0;
      game.q_uid = this.userService.user.uid;
    }

    this.draftService.queueGame(game);
    const c = this.ALL_GAMES.findIndex(oneGame => oneGame.game_id === game.game_id);
    this.ALL_GAMES[c] = game;
    this.filterGames(this.ALL_GAMES);
  }


  ngOnDestroy() {
    if (this.queueGameSubscription) {
      /* this.queueGameSubscription.unsubscribe(); */
    }

    /* this.pickTicketSubscription.unsubscribe(); */
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/draft/components/draft-queue/draft-queue.component.ts